import {faSort, faSortDown, faSortUp} from '@fortawesome/pro-solid-svg-icons';
import styled, {css} from 'styled-components';

import {Icon} from '../../components/Icon/Icon';
import {scToTwColour} from '../../theme';

import type {HeadingParams, TableSortBy} from './Table';

type Props<T> = {
  heading: HeadingParams<T>;
  sortBy: TableSortBy | null;
  setSortBy: React.Dispatch<React.SetStateAction<TableSortBy | null>>;
  children: React.ReactNode;
};
export function TableHeading<T>(props: Props<T>): React.JSX.Element {
  if (!props.heading.sortFn) {
    return (
      <StyledHeading width={props.heading.width}>
        {props.children}
      </StyledHeading>
    );
  }

  const handleClick = (): void => {
    return props.setSortBy((state) => ({
      prop: props.heading.prop,
      isAsc: state && props.heading.prop === state.prop ? !state.isAsc : false,
    }));
  };

  let icon = faSort;
  if (props.heading.prop === props.sortBy?.prop) {
    if (props.sortBy.isAsc) icon = faSortUp;
    else icon = faSortDown;
  }

  return (
    <StyledHeading width={props.heading.width}>
      <button type="button" onClick={handleClick}>
        <StyledIcon icon={icon} />
        {props.children}
      </button>
    </StyledHeading>
  );
}

export const StyledHeading = styled.th<{width?: string}>`
  color: ${scToTwColour('theme.colours.slate11')};
  white-space: nowrap;
  border-bottom: 1px solid ${scToTwColour('theme.colours.slate6')};

  ${({width}) =>
    !!width &&
    css`
      width: ${width};
    `}

  & button {
    display: block;
    width: 100%;
    color: ${scToTwColour('theme.colours.slate12')};
    font-weight: 700;
    text-align: left;
    background-color: transparent;
    outline: none;
    cursor: pointer;
  }

  & button:hover,
  & button:focus {
    color: ${scToTwColour('theme.colours.blue11')};
  }
`;
const StyledIcon = styled(Icon)`
  margin-right: 0.3em;
`;
